/**
 * My Account → Certificates tab.
 *
 * Wires the "Download Certificate" and "Generate Certificate" buttons in the
 * cert grid to the existing /api/certificate endpoints — handling both
 * Participation and Completion certificate types (ported from the legacy
 * portfolio-dashboard-web flow).
 *
 *   - Download  GET  /api/certificate/download?name=<cert>  → emails the PDF.
 *               Throttled to once per 3 minutes per cert via localStorage.
 *   - Generate  POST /api/certificate/generate (program + type) → issues the
 *               cert, then reloads so the new "Download" card appears.
 */
document.addEventListener('DOMContentLoaded', function () {
    var panel = document.querySelector('.myaccount__certificates');
    if (!panel) return;

    var THROTTLE_KEY = 'certificate_timer';
    var THROTTLE_MINUTES = 3;

    panel.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cert-action]');
        if (!btn) return;

        var action = btn.dataset.certAction;
        if (action === 'download') {
            downloadCertificate(btn);
        } else if (action === 'generate') {
            generateCertificate(btn);
        }
    });

    function setLoading(btn, isLoading) {
        btn.disabled = isLoading;
        btn.classList.toggle('myaccount__cert-card-cta--loading', isLoading);
    }

    function readThrottle() {
        try {
            return JSON.parse(localStorage.getItem(THROTTLE_KEY)) || {};
        } catch (_) {
            return {};
        }
    }

    async function downloadCertificate(btn) {
        var certName = btn.dataset.certValue;
        if (!certName) return;

        var store = readThrottle();
        var prev = store[certName] ? new Date(store[certName]) : null;
        if (prev && (Math.abs(new Date() - prev) / 1000 / 60) <= THROTTLE_MINUTES) {
            notify('Certificate has already been sent. Please try again after 3 minutes.', 'error');
            return;
        }

        setLoading(btn, true);
        try {
            var res = await fetch('/api/certificate/download?name=' + encodeURIComponent(certName), {
                headers: { 'Accept': 'application/json' }
            });
            var body = await res.json().catch(function () { return {}; });

            if (body && body.status === 1) {
                store[certName] = new Date().toISOString();
                try { localStorage.setItem(THROTTLE_KEY, JSON.stringify(store)); } catch (_) {}
                notify(body.message || 'Certificate has been sent to your mail.', 'success');
            } else {
                notify((body && body.message) || 'Unable to download certificate. Please try again.', 'error');
            }
        } catch (err) {
            console.error('certificate download failed', err);
            notify('Network error. Please try again.', 'error');
        } finally {
            setLoading(btn, false);
        }
    }

    async function generateCertificate(btn) {
        var program = btn.dataset.certValue;
        var type = btn.dataset.certType || '';
        if (!program) return;

        setLoading(btn, true);
        try {
            var form = new URLSearchParams();
            form.append('program', program);
            if (type) form.append('type', type);

            var res = await fetch('/api/certificate/generate', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: form.toString()
            });
            var body = await res.json().catch(function () { return []; });

            // The backend answers with one {status, message} entry per program
            // (several for a bundle). Join them into ONE toast — notify()
            // replaces any visible toast, so per-item calls would only ever
            // show the last message.
            var results = Array.isArray(body) ? body : [body];
            var issued = false;
            var messages = [];
            results.forEach(function (item) {
                if (!item) return;
                if (item.status === 1) issued = true;
                if (item.message) messages.push(item.message);
            });

            if (messages.length) {
                notify(messages.join('\n'), issued ? 'success' : 'error');
            } else {
                notify('Unable to generate certificate. Please try again.', 'error');
            }

            // Reload so the newly issued cert moves into the "Download" grid.
            if (issued) {
                setTimeout(function () { window.location.reload(); }, 1200);
            }
        } catch (err) {
            console.error('certificate generate failed', err);
            notify('Network error. Please try again.', 'error');
        } finally {
            setLoading(btn, false);
        }
    }

    // Lightweight top-center toast — matches the enrollment-popup pattern so we
    // don't pull in a new notification dependency.
    function notify(message, type) {
        var existing = document.getElementById('cert-notification');
        if (existing) existing.remove();

        var div = document.createElement('div');
        div.id = 'cert-notification';
        div.style.cssText = 'position:fixed;top:20px;left:50%;transform:translateX(-50%);'
            + 'z-index:100000;padding:14px 28px;border-radius:8px;font-size:15px;'
            + 'font-weight:500;color:#fff;box-shadow:0 4px 20px rgba(0,0,0,0.3);'
            + 'transition:opacity 0.4s ease;max-width:90vw;text-align:center;'
            + 'white-space:pre-line;';
        div.style.background = type === 'error' ? '#d9534f' : '#28a745';
        div.textContent = message;
        document.body.appendChild(div);

        setTimeout(function () {
            div.style.opacity = '0';
            setTimeout(function () { div.remove(); }, 500);
        }, 5000);
    }
});
